import { ListItem as MuiListItem } from '@material-ui/core'
import styled from 'styled-components'

export const ListItem = styled(MuiListItem)`
  ${({ theme }) => `
    padding-left: ${theme.spacing(6)}px
  `}
`
